/*
 * dt-box-cart-remove.js
 * 定期便ボックスのカート「削除」ボタン専用ハンドラ。
 *
 * 定期便ボックスは「親 + 子6点 = 計7行」が同じ boxId プロパティを共有する。
 * 「削除」クリック時、その boxId に一致する行だけをカートから削除し、
 * カート内のそれ以外の商品（通常商品など）は残す。
 * （従来の href="/cart/clear" ＝カート全消去 を置き換える。/cart/clear は
 *  この JS が無効・未ロードのときのフォールバックとして href に残してある。）
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cart-item__box-remove');
    if (!button) return;

    var boxId = button.getAttribute('data-box-id');
    // boxId が取れないときは何もしない（href の /cart/clear にフォールバック）
    if (!boxId) return;

    event.preventDefault();

    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');

    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        // boxId が一致する行（親 + 子6点）の数量を 0 にする更新オブジェクトを作る
        var updates = {};
        (cart.items || []).forEach(function (item) {
          if (item.properties && item.properties.boxId === boxId) {
            updates[item.key] = 0;
          }
        });

        // 対象行が無い場合（既に削除済み等）はそのまま再読込
        if (Object.keys(updates).length === 0) {
          return Promise.resolve();
        }

        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ updates: updates }),
        });
      })
      .then(function () {
        // カート画面を再読込して表示を最新化
        window.location.reload();
      })
      .catch(function () {
        // 失敗時もカートを再読込（現在の状態をユーザーに見せる）
        window.location.reload();
      });
  });
})();
